import globalConfig from '@utiles/officialStore/globalConfig';
import { getPrivacyLink, getServiceLink, getJpServicePrivacyLink, getJpCustomizeLink } from '@utiles/reviewFooter';
import { mapGetters, mapState } from 'vuex';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
const mainHost = globalConfig.getMainHost();

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    ...mapGetters(['isJpPlatform']),
    isJp() {
      const iso_two_code =
        localStorage.getItem('locationDetectByIP') &&
        JSON.parse(localStorage.getItem('locationDetectByIP')); // 根据 IP 获取地区码
      const area = iso_two_code && iso_two_code['ISO_TWO_CODE'];
      return area === 'JP' || globalConfig.getLanguages() === 'ja-JP';
    },
    // 2024.2.2 隐私协议条款链接带上gameId参数 用于后端判断重定向
    serviceLink() {
      const reviewServiceLink = getServiceLink(this.gameId);
      if (reviewServiceLink) {
        return reviewServiceLink;
      }
      if (this.isJpPlatform) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivicy/service?gameId=${this.gameId}&language=jp`;
      }
      return `https://gpassport.${mainHost}/center/${this.isJp ? 'Jp' : ''
        }ServicePrivacy/service?gameId=${this.gameId}`;
    },
    privacyLink() {
      const reviewPrivacyLink = getPrivacyLink(this.gameId);
      if (reviewPrivacyLink) {
        return reviewPrivacyLink;
      }
      if (this.isJpPlatform) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/privacy?gameId=${this.gameId}&language=jp`;
      }
      return `https://gpassport.${mainHost}/center/${this.isJp ? 'Jp' : ''
        }ServicePrivacy/privacy?gameId=${this.gameId}`;
    }
  },
  methods: {
    openServiceLink() {
      sdkOpenLink({
        link: this.serviceLink,
        loginDir: 0,
        appendParams: 0
      });
    },
    openPrivacyLink() {
      sdkOpenLink({
        link: this.privacyLink,
        loginDir: 0,
        appendParams: 0
      });
    },
    openJpServicePrivacyLink() {
      sdkOpenLink({
        link: getJpServicePrivacyLink(this.gameId),
        loginDir: 0,
        appendParams: 0
      });
    },
    openJpCustomizeLink() {
      sdkOpenLink({
        link: getJpCustomizeLink(this.gameId),
        loginDir: 0,
        appendParams: 0
      });
    }
  }
};
